import { Component, OnInit } from '@angular/core';
import { ApiService } from '@api/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'rav-backup-codes',
  templateUrl: './backup-codes.component.html',
  styleUrls: ['./backup-codes.component.scss']
})
export class BackupCodesComponent implements OnInit {
  backupCodes: string[];

  constructor(private api: ApiService) {}

  ngOnInit() {}

  generateCodes(): void {
    this.api.users.me.twoFactor.backup.patch().subscribe((data) => {
      this.backupCodes = data;
    });
  }

  copyCodes(): void {
    const linkBox = document.createElement('textarea');
    linkBox.style.position = 'fixed';
    linkBox.style.left = '0';
    linkBox.style.top = '0';
    linkBox.style.opacity = '0';
    linkBox.value = this.backupCodes.toString();
    document.body.appendChild(linkBox);
    linkBox.focus();
    linkBox.select();
    document.execCommand('copy');
    document.body.removeChild(linkBox);
  }
}
